<span class='title'>Etat des sous-systèmes</span>

<mat-spinner color='primary' [diameter]='20' *ngIf='isLoading$|async'></mat-spinner>

<div #anchor *ngIf='!(isLoading$|async)' class='clickable' (click)='toggle()' fxLayout='column'
     fxLayoutAlign='center center' fxLayoutGap='5px'>
  <div class='colored-circle'
       [style.backgroundColor]='colors[summarySubSystemState]'>
    {{summary}}
  </div>
</div>

<kendo-popup
  #popup
  [anchor]='anchor'
  [anchorAlign]='anchorAlign'
  (anchorViewportLeave)='show = false'
  *ngIf='show'>
  <div class='content'>

    <section class='k-border k-border-solid k-border-dark'>
      <div fxLayout='row' fxLayoutAlign='space-between center' fxLayoutGap='5px'>
        <span style='padding: 0 16px'>Sous-sytèmes</span>
        <button mat-icon-button color='accent' (click)='toggle()'>
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </section>

    <section *ngIf='(subSystems$|async)?.length > 0' fxLayout='row' fxLayoutAlign='center' fxLayoutGap='10px'
             style='padding: 10px 16px'>
      <a [href]='item.urlAcces'
         target='_blank'
         (click)='onClick(item)' *ngFor='let item of (subSystems$|async)' fxLayout='column'>
        <div class='colored-circle'
             [style.backgroundColor]='colors[item.idEtatSysteme]'>
          {{item.nom}}
        </div>
      </a>
    </section>

  </div>
</kendo-popup>
